<template>
  <div class="min-h-screen bg-base-100 flex flex-col">
    <!-- Header -->
    <MainHeader :isSticky="false" :isMinimal="false" :scrolled="false" />

    <!-- Main content -->
    <main class="flex-grow w-full p-6">
      <!-- Title + language toggle + breadcrumbs -->
      <div class="flex items-center justify-between mb-8">
        <div>
          <div class="breadcrumbs text-sm mb-2">
            <ul>
              <li><RouterLink to="/dashboard">Dashboard</RouterLink></li>
              <li v-if="$route.name !== 'Dashboard'">{{ $route.name }}</li>
            </ul>
          </div>
          <h1 class="text-3xl font-semibold">
            {{ $route.name === 'Dashboard' ? t("dashboard.overview") : $route.name }}
          </h1>
          <p class="text-gray-600 mt-1">
            {{ $route.name === 'Dashboard' ? 'Restricted access dashboard for authenticated users' : 'Dashboard tool for authenticated users' }}
          </p>
        </div>
        <button @click="switchLang" class="btn btn-sm">
          {{ locale === "en" ? "NL" : "EN" }}
        </button>
      </div>

      <!-- Child route content -->
      <router-view />
    </main>

    <!-- Footer -->
    <Footer />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { RouterLink } from "vue-router";
import MainHeader from "@/components/headers/MainHeader.vue";
import Footer from "@/components/Footer.vue";

const { t, locale } = useI18n();

function switchLang() {
  locale.value = locale.value === "en" ? "nl" : "en";
}
</script>
